import React, { PropsWithChildren } from 'react';
import TempResetLink from '../TempResetLink';
import './FormSection.css';

interface Props {
  className?: string;
}

const FormSection: React.FC<PropsWithChildren<Props>> = ({ children, className }) => {
  return (
    <section className={`form-section ${className ?? ''}`}>
      <div className="form-section_content" data-test="form-section-content">
        {children}
        <TempResetLink />
      </div>
    </section>
  );
};

export default FormSection;
